import {Constants} from '@article-overview/components/view-constants.js';
import type {SearchAttribution} from '@article-overview/hooks/useArticleNavigation';

type ResponseMetadata = {
    queryId?: string;
};

export function buildSearchAttribution(
    responseMetadata: ResponseMetadata | undefined,
    searchIndexName: string | undefined,
    activeSearchEngine: string | undefined,
    positionIndex: number | undefined,
    loadMoreButtonTestGroup: boolean | undefined,
    objectId: string | undefined
): SearchAttribution | null {
    if (
        !responseMetadata?.queryId ||
        !searchIndexName ||
        activeSearchEngine !== 'ALGOLIA' ||
        positionIndex === undefined
    ) {
        return null;
    }
    const currentPage =
        parseInt(new URLSearchParams(window.location.search).get(Constants.SEARCH_PARAMS_PAGE) ?? '1', 10) || 1;
    // Algolia expects 1-based positions, positionIndex is 0-based
    const absolutePosition = loadMoreButtonTestGroup
        ? positionIndex + 1
        : (currentPage - 1) * Constants.PAGE_SIZE + positionIndex + 1;
    return {
        queryID: responseMetadata.queryId,
        position: absolutePosition,
        objectID: objectId,
    };
}
